import {
    gfile,
    gcontentlist,
    gloggedinuser,
    highLightItem,
    gXplrrFileOrder,
    gXplrrSpaceOrder,
    gXplrrSpaceIndex,
    gXplrrExtendedFileList,
    gXplrrContentListFileOrder,
    empty_extraction_field_list,
    gXplrrCitationChangeCallback
} from "../../interfaces";
import { emptyValNumObj } from "../../lsts";
import { addDotIfNeeded } from "../../util_glob";


export const getDefaultFileOrderFromCache = (fileList: gfile[]): gXplrrContentListFileOrder => {
    //**  Content List: File Order from Cache */
    const defaultOrder: gXplrrContentListFileOrder = {};
    fileList.map((flfile, flIndex) => {
        defaultOrder[flfile.fileid] = flIndex;
    });
    return defaultOrder;
};

export const contentListValueNumbering = (item: gcontentlist) => {
    //**  Content List: Value Numbering */
    const currentValue = item.destPageNum;
    if (item.srcText) {
        let splitValues = item.srcText.trim().replace(" .", ".").split(" ");
        let pageNum = item.destPageNum;
        if (!isNaN(Number(splitValues[splitValues.length - 1]))) {
            pageNum = parseInt(splitValues[splitValues.length - 1]);
            splitValues.pop();
        }
        if (!splitValues || splitValues.length == 0) {
            return emptyValNumObj;
        }
        return {
            currentValue: currentValue.toString(),
            splitValues: splitValues,
            splitLength: splitValues.length,
            itemLevel: (addDotIfNeeded(splitValues[0]).match(/\./g) || []).length - 1,
            pageNumExtracted: pageNum
        };
    } else {
        return emptyValNumObj;
    }
};

export const fileMapGen = (fileList: gfile[]) => {
    //**  Content List: File Map Generation */
    let fileMap: gXplrrSpaceOrder = {};
    fileList.map((flfile, flIndex) => {
        let arrItems: gXplrrFileOrder = {
            order: flIndex,
            opened: false,
            fileItemOrder: {}
        };
        if (flfile.contentlist && flfile.contentlist.length > 0) {
            flfile.contentlist.forEach((flItem, flItemIndex) => {
                const { currentValue, splitValues, splitLength, itemLevel, pageNumExtracted } = contentListValueNumbering(flItem);
                arrItems.fileItemOrder[flItemIndex] = {
                    opened: false,
                    currentValue: currentValue,
                    splitValues: splitValues,
                    splitLength: splitLength,
                    itemLevel: itemLevel,
                    pageNumExtracted: pageNumExtracted
                };
            });
        }
        fileMap[parseInt(flfile.fileid)] = arrItems;
    });
    return fileMap;
};